<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M18.0142 3.9978C16.9092 3.9978 16.0142 4.8928 16.0142 5.9978V17.9978C16.0142 19.1028 16.9092 19.9978 18.0142 19.9978H20.0142C21.1192 19.9978 22.0142 19.1028 22.0142 17.9978V5.9978C22.0142 4.8928 21.1192 3.9978 20.0142 3.9978H18.0142ZM18.0142 5.9978H20.0142V17.9978H18.0142V5.9978ZM11.0142 7.9978C9.90917 7.9978 9.01416 8.8928 9.01416 9.9978V17.9978C9.01416 19.1028 9.90917 19.9978 11.0142 19.9978H13.0142C14.1192 19.9978 15.0142 19.1028 15.0142 17.9978V9.9978C15.0142 8.8928 14.1192 7.9978 13.0142 7.9978H11.0142ZM11.0142 9.9978H13.0142V17.9978H11.0142V9.9978ZM4.01416 11.9978C2.90916 11.9978 2.01416 12.8928 2.01416 13.9978V17.9978C2.01416 19.1028 2.90916 19.9978 4.01416 19.9978H6.01416C7.11916 19.9978 8.01416 19.1028 8.01416 17.9978V13.9978C8.01416 12.8928 7.11916 11.9978 6.01416 11.9978H4.01416ZM4.01416 13.9978H6.01416V17.9978H4.01416V13.9978Z"
    />
  </svg>
</template>
